import { useMutation } from '@apollo/client';
import {
  useCachedMutations,
  useOnlineStatus,
  removeFunctionsFromOptions,
} from './offline-misc';
import { v4 as uuidv4 } from 'uuid';
import { loader } from 'graphql.macro';
import { useWorkspace } from '../../providers/WorkspaceProvider';
import { useCurrentUser } from '../../providers/UserProvider';
import { cleanIndexedDB } from '../../utilities';
import { useApolloClient } from '@apollo/client';

const addObservationMutation = loader(
  '../../components/modals/provider_modals/ObservationModal.graphql',
);
const userFragment = loader('./User.userFragment.graphql');

const observationQuery = loader(
  '../../pages/observations/ObservationList.fetch.graphql',
);

export const useObservations = () => {
  const client = useApolloClient();
  const { workspace: currentWorkspace } = useWorkspace();
  const online = useOnlineStatus();
  const { addMutation } = useCachedMutations();
  const { user: currentUser } = useCurrentUser();

  const [addObservation] = useMutation(addObservationMutation);

  const addObservations = async (options) => {
    if (online) {
      return addObservation(options);
    } else {
      const uuid = uuidv4().toString();

      const participantsFragementData = options.variables.participants.map(
        (participant) => {
          const participantData = client.readFragment({
            id: `User:${participant}`,
            fragment: userFragment,
          });

          return participantData;
        },
      );

      const mockResult = ({ variables }) => {
        const obj = {
          __typename: 'Observation',
          id: uuid,
          status: 'NEW',
          workspace: currentWorkspace,
          participants: participantsFragementData,
          creator: currentUser,
          dateTime: null,
          dateCreated: null,
          dateClosed: null,
          externalId: null,
          dateModified: null,
          description: null,
          dateReviewed: null,
          notes: null,
          items: null,
          title: null,
          type: null,
          location: null,
          negative: null,
          private: false,
          riskAnalysis: null,
          incident: null,
          images: null,
          reviewer: null,
          closer: null,
          actionItems: [],
          labels: [],
          user: {},
          reconition: false,
        };

        const keysToSkip = ['participants', 'show', 'urlParams', 'refetch'];

        Object.entries(variables).forEach(([key, value]) => {
          if (!!value) {
            if (!keysToSkip.includes(key)) {
              obj[key] = value;
            }
          } else {
            obj[key] = null;
          }
        });

        return obj;
      };

      await addMutation(
        addObservationMutation,
        cleanIndexedDB(removeFunctionsFromOptions(options)),
        uuid,
        mockResult(options),
        [''],
        '',
      );

      client.writeQuery({
        query: observationQuery,
        variables: { id: `${uuid}` },
        data: { observations: [mockResult(options)], observationCount: 1 },
      });

      return new Promise((resolve, reject) => {
        const responseData = {
          data: {
            addObservation: { id: uuid },
          },
        };
        resolve(responseData);
      });
    }
  };

  return {
    addObservations,
  };
};
